export default "__VITE_ASSET__44349d6f__"